module.exports = "/_next/static/images/c8ff56f57a445b450a0ccc36d43d4a26-mastercard-right-small.jpg";